import { createRoute, lazyRouteComponent, type AnyRootRoute } from '@tanstack/react-router'
import { i18n } from '../../shared/i18n/i18n'
import sv from './locales/sv.json'
import en from './locales/en.json'

i18n.addResourceBundle('sv', 'auth', sv, true, true)
i18n.addResourceBundle('en', 'auth', en, true, true)

export function buildAuthRoutes<TRoot extends AnyRootRoute>(rootRoute: TRoot) {
  return [
    createRoute({
      getParentRoute: () => rootRoute,
      path: '/login',
      component: lazyRouteComponent(() => import('./pages/LoginPage'), 'LoginPage'),
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: '/signup',
      component: lazyRouteComponent(() => import('./pages/SignUpPage'), 'SignUpPage'),
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: '/resetPassword',
      component: lazyRouteComponent(() => import('./pages/ResetPasswordPage'), 'ResetPasswordPage'),
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: '/activation/$token',
      component: lazyRouteComponent(() => import('./pages/ActivationPage'), 'ActivationPage'),
    }),
    // V2 magic-link sign-in (CLUB-104). /auth/v2/send accepts an email and
    // POSTs to /api/v1/auth/v2/send-link. /auth/v2/landing is the Firebase
    // actionUrl target — completes signInWithEmailLink and then POSTs to
    // /api/v1/auth/v2/bind.
    createRoute({
      getParentRoute: () => rootRoute,
      path: '/auth/v2/send',
      component: lazyRouteComponent(() => import('./pages/MagicLinkSendPage'), 'MagicLinkSendPage'),
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: '/auth/v2/landing',
      component: lazyRouteComponent(() => import('./pages/MagicLinkLandingPage'), 'MagicLinkLandingPage'),
    }),
  ]
}
